import React from "react";

import styled from "styled-components";

const Container = styled.div`
  margin-right: 50px;
  padding: 20px;
  -webkit-box-shadow: 0px 0px 17px -11px rgba(0, 0, 0, 0.58);
  box-shadow: 0px 0px 17px -11px rgba(0, 0, 0, 0.58);
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 480px) {
    margin-right: 0;
    margin-bottom: 10px;
    padding: 10px;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Price = styled.span`
  font-weight: bold;
  font-size: 50px;
  @media only screen and (max-width: 480px) {
    font-size: 30px;
  }
`;

const Type = styled.button`
  padding: 10px;
  margin: 10px 0;
  border: 1.5px solid crimson;
  color: crimson;
  background-color: white;
  border-radius: 20px;
  &:hover {
    background-color: crimson;
    color: white;
  }
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const List = styled.ul`
  list-style: none;
`;

const ListItem1 = styled.li`
  margin: 30px 0;
  @media only screen and (max-width: 480px) {
    margin: 10px;
    font-size: 12px;
  }
`;

const ListItem4 = styled.li`
  margin: 30px 0;
  @media only screen and (max-width: 480px) {
    margin: 10px;
    font-size: 12px;
  }
`;

const ListItem2 = styled.li`
  margin: 30px 0;
  text-decoration: ${({ price }) => (price < 30 ? "line-through red" : "none")};
  @media only screen and (max-width: 480px) {
    margin: 10px;
    font-size: 12px;
  }
`;
const ListItem3 = styled.li`
  margin: 30px 0;
  text-decoration: ${({ price }) => (price < 20 ? "line-through red" : "none")};
  @media only screen and (max-width: 480px) {
    margin: 10px;
    font-size: 12px;
  }
`;

const Button = styled.button`
  border: none;
  background-color: darkblue;
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background-color: blue;
  }
  @media only screen and (max-width: 480px) {
    font-size: 12px;
    padding: 5px;
  }
`;

const LinkRel = styled.a`
  text-decoration: none;
  color: white;
`;
const contentCard = [
  {
    price: 10,
    offer: "Basic Plan",
    options: [
      {
        option1: "200 Hand-Crafted Templates",
        option2: "Exclusive Support",
        option3: "50+ PreBuilt Websites",
        option4: "Premium Plugins",
      },
    ],
  },
  {
    price: 20,
    offer: "Premuim Plan",
    options: [
      {
        option1: "200 Hand-Crafted Templates",
        option2: "Exclusive Support",
        option3: "50+ PreBuilt Websites",
        option4: "Premium Plugins",
      },
    ],
  },
  {
    price: 30,
    offer: "Advanced Plan",
    options: [
      {
        option1: "200 Hand-Crafted Templates",
        option2: "Exclusive Support",
        option3: "50+ PreBuilt Websites",
        option4: "Premium Plugins",
      },
    ],
  },
];

const PriceCard = () => {
  return (
    <>
      {contentCard?.map((content, index) => (
        <Container key={`${content.price}-${index}`}>
          <PriceContainer>
            $<Price>{content.price}</Price>
            /month
          </PriceContainer>
          <Type>{content.offer}</Type>
          <List>
            {content?.options?.map((list, indexList) => (
              <div key={`${list.option1}-${indexList}`}>
                <ListItem1>{list.option1}</ListItem1>
                <ListItem2 price={content.price}>{list.option2}</ListItem2>
                <ListItem3 price={content.price}>{list.option3}</ListItem3>
                <ListItem4>{list.option4}</ListItem4>
              </div>
            ))}
          </List>
          <Button>
            <LinkRel href="https://www.youtube.com/channel/UCWB0VzsNRN0GN5ZROArj4ag">
              Join Now
            </LinkRel>
          </Button>
        </Container>
      ))}
    </>
  );
};

export default PriceCard;
